/* Breakfree checkout offer */
(function () {
  'use strict';
  if (window.bfOffer) return;
  var dataEl = document.getElementById('bf-offer-data');
  if (!dataEl) return;
  var C;
  try { C = JSON.parse(dataEl.textContent); } catch (e) { console.error('[bf-offer] settings could not be read', e); return; }
  var T = C.t || {};
  var R = C.root || '/';
  if (R.slice(-1) !== '/') R += '/';
  var SEEN = 'bfco-seen';
  var design = !!(window.Shopify && Shopify.designMode);
  var OFFERS = (C.offers || []).map(function (o) {
    o.variants = (o.variants || []).filter(function (v) { return v.ok && v.price < v.was; });
    return o;
  }).filter(function (o) { return o.variants.length; });
  if (!OFFERS.length) return;

  var SCRIB = 'M62 9C150 -2 262 6 290 38C310 66 250 94 150 95C60 96 4 80 6 50C8 22 70 6 160 7C200 8 236 12 262 22';
  var I = {
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    box: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7l9-4 9 4v10l-9 4-9-4z"/><path d="M3 7l9 4 9-4M12 11v10"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="7" width="12" height="9" rx="1"/><path d="M14 10h4l3 3v3h-7"/><circle cx="6" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/></svg>'
  };

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function circ(t) { return '<span class="bfco-c">' + esc(t) + '<svg viewBox="0 0 300 100" preserveAspectRatio="none" aria-hidden="true"><path pathLength="1" d="' + SCRIB + '"/></svg></span>'; }
  function money(cents) {
    var n = (cents || 0) / 100, f = C.money || '${{amount}}';
    function grp(x, d, th, dec) { var p = x.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(dec); }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return grp(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return grp(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(n, 0, '.', ',');
      return grp(n, 2, ',', '.');
    }).replace(/<[^>]*>/g, '');
  }
  function label(t) { t = String(t || ''); return t === 'Default Title' ? '' : t.replace(/\s*["“]([^"”]+)["”]\s*$/, ' · $1'); }
  function seen() { try { return sessionStorage.getItem(SEEN) === '1'; } catch (e) { return false; } }
  function markSeen() { try { sessionStorage.setItem(SEEN, '1'); } catch (e) {} }
  function getCart() { return window.fetch(R + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function post(path, body) {
    return window.fetch(R + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function emit(name) { try { document.dispatchEvent(new CustomEvent(name)); } catch (e) {} }

  /* ---------- which product to offer ---------- */
  function base(cart) { var s = 0; (cart.items || []).forEach(function (i) { if (!(i.properties && i.properties._bf_gift)) s += i.final_line_price; }); return s; }
  function choose(cart) {
    if (!cart || !cart.items || !cart.items.length) return null;
    if (C.under > 0 && cart.total_price >= C.under * 100) return null;
    for (var k = 0; k < OFFERS.length; k++) {
      var o = OFFERS[k];
      var has = cart.items.some(function (i) { return o.pids.indexOf(i.product_id) > -1; });
      if (!has) return o;
    }
    return null;
  }

  /* ---------- popup ---------- */
  var root = null, ov = null, cur = null, vi = 0, cart0 = null, trig = null, pass = false, isOpen = false, busy = false, added = false;
  function ensureRoot() {
    root = document.getElementById('bf-offer');
    if (!root) { root = document.createElement('div'); root.id = 'bf-offer'; document.body.appendChild(root); }
    if (root.parentNode !== document.body) document.body.appendChild(root);
    return root;
  }
  function trustHTML(v) {
    var up = C.shipAt > 0 && cart0 && base(cart0) < C.shipAt && base(cart0) + v.price >= C.shipAt;
    return '<span>' + I.box + esc(T.trust1) + '</span><span' + (up ? ' class="up"' : '') + '>' + I.truck + esc(up ? T.unlock : T.trust2) + '</span>';
  }
  function popHTML() {
    var o = cur, v = o.variants[vi], pctOff = Math.round((1 - v.price / v.was) * 100);
    var many = o.variants.length > 1;
    return '<button type="button" class="bfco-x" data-co="close" aria-label="' + esc(T.close) + '">' + I.x + '</button>' +
      '<div class="bfco-head"><span class="bfco-kick"><i></i>' + esc(T.kick) + '</span>' +
      '<h2 class="bfco-hl" id="bfco-t">' + esc(T.h1) + '<br><span class="bfco-nw">' + circ(T.h1c) + esc(T.h1end) + '</span></h2>' +
      '<p class="bfco-sub">' + esc(T.sub) + '</p></div>' +
      '<div class="bfco-card"><div class="bfco-ph' + (o.fit === 'contain' ? ' contain' : '') + '" style="--c:' + esc(o.bg || '#FCEAEF') + '"><img data-co-img src="' + esc(v.img) + '" alt="' + esc(o.name) + '" width="250" height="250"><span class="bfco-badge" data-co-pct>-' + pctOff + '%</span></div>' +
      '<div><p class="bfco-name">' + esc(o.name) + '</p>' + (o.why ? '<p class="bfco-why">' + esc(o.why) + '</p>' : '') +
      '<div class="bfco-price"><b data-co-price>' + esc(money(v.price)) + '</b><s data-co-was>' + esc(money(v.was)) + '</s><span class="bfco-save" data-co-save>' + esc(String(T.save).replace('[amount]', money(v.was - v.price))) + '</span></div></div></div>' +
      (many ? '<div class="bfco-sw"><small>' + esc(T.colour) + ': <b data-co-vname>' + esc(label(v.t)) + '</b></small><div class="bfco-dots" role="group" aria-label="' + esc(T.colour) + '">' +
        o.variants.map(function (x, i) { return '<button type="button" class="bfco-dot" data-co-v="' + i + '" aria-pressed="' + (i === vi) + '" title="' + esc(label(x.t)) + '" aria-label="' + esc(label(x.t)) + '"><img src="' + esc(x.img) + '" alt="" loading="lazy" width="46" height="46"></button>'; }).join('') +
        '</div></div>' : '') +
      '<button type="button" class="bfco-cta" data-co="add">' + I.plus + '<span data-co-cta>' + esc(String(T.add).replace('[price]', money(v.price))) + '</span></button>' +
      '<p class="bfco-err" role="alert"></p>' +
      '<div class="bfco-trust" data-co-trust>' + trustHTML(v) + '</div>' +
      '<button type="button" class="bfco-skip" data-co="skip">' + esc(T.skip) + '</button>';
  }
  function pickVariant(i) {
    if (!ov || added) return;
    vi = i;
    var v = cur.variants[vi], q = function (s) { return ov.querySelector(s); };
    q('[data-co-img]').src = v.img;
    if (q('[data-co-vname]')) q('[data-co-vname]').textContent = label(v.t);
    q('[data-co-price]').textContent = money(v.price);
    q('[data-co-was]').textContent = money(v.was);
    q('[data-co-save]').textContent = String(T.save).replace('[amount]', money(v.was - v.price));
    q('[data-co-pct]').textContent = '-' + Math.round((1 - v.price / v.was) * 100) + '%';
    q('[data-co-cta]').textContent = String(T.add).replace('[price]', money(v.price));
    q('[data-co-trust]').innerHTML = trustHTML(v);
    [].forEach.call(ov.querySelectorAll('[data-co-v]'), function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-co-v') === vi)); });
  }
  function show(o) {
    cur = o; vi = 0; added = false; busy = false; isOpen = true;
    markSeen();
    ensureRoot();
    ov = document.createElement('div');
    ov.className = 'bfco-ov';
    ov.innerHTML = '<div class="bfco-pop" role="dialog" aria-modal="true" aria-labelledby="bfco-t" tabindex="-1">' + popHTML() + '</div>';
    root.appendChild(ov);
    document.documentElement.classList.add('bfco-lock');
    ov.addEventListener('click', onClick);
    ov.addEventListener('touchmove', function (e) {
      var p = e.target.closest && e.target.closest('.bfco-pop, .bfco-dots');
      if (!p) e.preventDefault();
    }, { passive: false });
    var pop = ov.querySelector('.bfco-pop');
    try { pop.focus({ preventScroll: true }); } catch (e) {}
  }
  function hide() {
    isOpen = false;
    if (ov && ov.parentNode) ov.parentNode.removeChild(ov);
    ov = null;
    document.documentElement.classList.remove('bfco-lock');
  }
  function close() { if (!isOpen) return; hide(); trig = null; emit('bf:offer-close'); }
  function go() {
    hide();
    emit('bf:checkout');
    var t = trig; trig = null;
    if (t && document.documentElement.contains(t) && !t.disabled) {
      pass = true;
      try { t.click(); } catch (e) { location.href = R + 'checkout'; }
      setTimeout(function () { pass = false; }, 2000);
      return;
    }
    location.href = R + 'checkout';
  }
  function add(btn) {
    if (busy || added) return;
    var v = cur.variants[vi], err = ov.querySelector('.bfco-err');
    busy = true; btn.setAttribute('aria-busy', 'true'); err.textContent = '';
    post('cart/add.js', { items: [{ id: v.id, quantity: 1, properties: { _bf_offer: 'checkout' } }] }).then(function () {
      added = true; busy = false;
      btn.removeAttribute('aria-busy'); btn.classList.add('done');
      btn.innerHTML = I.check + '<span>' + esc(T.added) + '</span>';
      setTimeout(go, 900);
    }, function (e) {
      busy = false; btn.removeAttribute('aria-busy');
      err.textContent = (e && e.description) || T.fail;
      console.warn('[bf-offer] could not add the product', e);
    });
  }
  function onClick(e) {
    if (e.target === ov) { close(); return; }
    var t = e.target.closest ? e.target.closest('[data-co],[data-co-v]') : null;
    if (!t) return;
    if (t.hasAttribute('data-co-v')) { pickVariant(+t.getAttribute('data-co-v')); return; }
    var a = t.getAttribute('data-co');
    if (a === 'close') close();
    else if (a === 'skip') go();
    else if (a === 'add') add(t);
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen && !added) close(); });

  /* ---------- catch the checkout tap ---------- */
  var SEL = 'button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"], [data-bf-checkout]';
  document.addEventListener('click', function (e) {
    if (pass || design) return;
    var t = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!t || t.disabled || (t.closest && t.closest('#bf-offer'))) return;
    if (isOpen) { e.preventDefault(); e.stopPropagation(); return; }
    if (seen()) return;
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    trig = t;
    t.setAttribute('aria-busy', 'true');
    getCart().then(function (cart) {
      t.removeAttribute('aria-busy');
      var o = choose(cart);
      if (!o) { go(); return; }
      cart0 = cart;
      show(o);
    }, function () { t.removeAttribute('aria-busy'); go(); });
  }, true);

  window.bfOffer = {
    test: function () { try { sessionStorage.removeItem(SEEN); } catch (e) {} return getCart().then(function (c) { cart0 = c; var o = choose(c) || OFFERS[0]; show(o); return o.key; }); },
    reset: function () { try { sessionStorage.removeItem(SEEN); } catch (e) {} }
  };
  if (design) document.addEventListener('shopify:section:select', function (e) { if (e.target && /bf-checkout-offer/.test(e.target.id || '')) window.bfOffer.test(); });
})();
